import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="doc-page">
      <nav className="doc-nav" data-testid="terms-nav">
        <Link className="nav-logo" to="/" data-testid="nav-logo">
          <img src="/ruler-icon.png" alt="" className="nav-logo-icon-img-sm" />
          <span className="nav-logo-text-sm">Kids Size Finder</span>
        </Link>
        <Link className="nav-back" to="/" data-testid="nav-back-link">← Back to home</Link>
      </nav>

      <main className="doc-main" data-testid="terms-content">
        <div className="doc-header">
          <div className="doc-title">Terms of Service</div>
          <div className="doc-meta">Last updated: April 2026</div>
          <div className="doc-company">
            <strong>Outgrow Solutions Oy</strong> &nbsp;·&nbsp; Business ID: 3594133-7<br />
            Hedelmäkatu 1 A, 33270 Tampere, Finland<br />
            support@kidssizefinder.com
          </div>
        </div>

        <h2>1. Agreement to Terms</h2>
        <p>These Terms of Service constitute a legally binding agreement between you and Outgrow Solutions Oy concerning your access to and use of the Kids Size Finder mobile application, website (kidssizefinder.com), and all related services (collectively, the "Services").</p>
        <p>By accessing or using the Services, you agree that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must discontinue use immediately.</p>
        <p>We reserve the right to make changes to these Terms at any time. We will alert you by updating the "Last updated" date.</p>

        <h2>2. Intellectual Property Rights</h2>
        <p>Unless otherwise indicated, the Services and all content including source code, software, designs, text, and graphics are the proprietary property of Outgrow Solutions Oy or licensed to us. You are granted a limited licence to access and use the Services for your personal, non-commercial use only.</p>

        <h2>3. User Representations and Eligibility</h2>
        <p>By using the Services, you represent and warrant that:</p>
        <ul>
          <li>You are at least 18 years of age</li>
          <li>You have the legal capacity to agree to these Terms</li>
          <li>You will not access the Services through automated or non-human means</li>
          <li>You will not use the Services for any illegal or unauthorised purpose</li>
          <li>Your use of the Services will not violate any applicable law or regulation</li>
        </ul>
        <p><strong>Children Under 13 and COPPA Compliance</strong><br />The Services are not directed to children under 13. Children may not create accounts independently. When you create a child profile you represent that you are the parent or legal guardian with authority to provide consent for the collection and use of the child's personal information.</p>

        <h2>4. User Registration</h2>
        <p>You may register using Apple Sign In or Google OAuth. You are responsible for maintaining the confidentiality of your account and for all activity that occurs under your account.</p>

        <h2>5. Free Service</h2>
        <p>Kids Size Finder is provided free of charge. There are no subscription fees or in-app purchases. We reserve the right to introduce paid features in the future, in which case we will provide advance notice and these Terms will be updated accordingly.</p>

        <h2>6. Prohibited Activities</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Systematically retrieve data from the Services without written permission</li>
          <li>Make unauthorised use of the Services</li>
          <li>Circumvent any security-related features</li>
          <li>Use the Services for any illegal or unauthorised purpose</li>
          <li>Engage in any automated use of the system</li>
          <li>Interfere with or create an undue burden on the Services</li>
          <li>Attempt to impersonate another user</li>
          <li>Decipher, decompile, disassemble, or reverse engineer any software</li>
          <li>Upload or transmit viruses or any malicious material</li>
          <li>Use the Services in a manner inconsistent with any applicable laws or regulations</li>
        </ul>

        <h2>7. Child Profile Data</h2>
        <p>When you submit information about your child, you represent and warrant that you are the parent or legal guardian with full authority to provide this information. Child profile data — including measurements and date of birth — is used exclusively to generate clothing size recommendations and project growth using WHO growth curve data. It is not used for advertising, marketing, or any commercial purpose.</p>
        <p>You may delete any child profile or your entire account at any time through the Settings screen in the app. Deleted data is permanently removed within 30 days.</p>

        <h2>8. Size Recommendation Disclaimer</h2>
        <div className="highlight-box">
          <p>Clothing size recommendations are based on verified brand size chart data and the measurements you provide. Actual fit may vary by brand, style, cut, and individual child. We do not guarantee that recommended sizes will fit your child perfectly. Recommendations are provided as a guide only and we accept no liability for purchasing decisions made based on our recommendations.</p>
        </div>

        <h2>9. Services Management</h2>
        <p>We reserve the right to monitor the Services for violations, take appropriate legal action, refuse or restrict access, and manage the Services to protect our rights and property.</p>

        <h2>10. Privacy Policy</h2>
        <p>Please review our Privacy Policy at kidssizefinder.com/privacy. By using the Services, you agree to be bound by our Privacy Policy. The Services are hosted in the United States. If you access the Services from any other region, you expressly consent to have your data transferred to and processed in the United States.</p>

        <h2>11. Term and Termination</h2>
        <p>These Terms shall remain in full force while you use the Services. We reserve the right to deny access to the Services to any person for any reason. If we terminate your account you are prohibited from registering a new account without our express written permission.</p>

        <h2>12. Modifications and Interruptions</h2>
        <p>We reserve the right to change, modify, or remove the contents of the Services at any time without notice. We cannot guarantee the Services will be available at all times and accept no liability for any interruption or discontinuation of the Services.</p>

        <h2>13. Governing Law</h2>
        <p>These Terms are governed by and construed in accordance with the laws of Finland, without regard to its conflict of law provisions.</p>

        <h2>14. Dispute Resolution</h2>
        <p><strong>Informal Negotiations</strong> — The parties agree to first attempt to resolve any dispute informally for at least 30 days before initiating any legal proceedings.</p>
        <p><strong>Jurisdiction</strong> — Any legal action shall be commenced or prosecuted in the courts of Helsinki, Finland.</p>

        <h2>15. Disclaimer</h2>
        <p className="caps-text">THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>

        <h2>16. Limitations of Liability</h2>
        <p className="caps-text">IN NO EVENT WILL WE BE LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICES. BECAUSE THE SERVICES ARE PROVIDED FREE OF CHARGE, OUR TOTAL LIABILITY TO YOU FOR ANY CAUSE OF ACTION SHALL NOT EXCEED €100.</p>

        <h2>17. Indemnification</h2>
        <p>You agree to defend, indemnify, and hold us harmless from and against any loss, damage, liability, claim, or demand arising out of your use of the Services, your breach of these Terms, or your violation of any third-party rights.</p>

        <h2>18. User Data</h2>
        <p>You are responsible for the accuracy of the data you provide. We perform regular backups but you are solely responsible for ensuring the measurements and information you enter are correct.</p>

        <h2>19. Electronic Communications</h2>
        <p>By using the Services you consent to receive electronic communications from us. All agreements, notices, and other communications we provide electronically satisfy any legal requirement that such communications be in writing.</p>

        <h2>20. Miscellaneous</h2>
        <p>These Terms constitute the entire agreement between you and us regarding the Services. If any provision is determined to be unlawful or unenforceable, that provision is deemed severable and does not affect the remaining provisions. Our failure to exercise any right shall not constitute a waiver of that right.</p>

        <h2>21. Contact Us</h2>
        <p>Outgrow Solutions Oy<br />Hedelmäkatu 1 A, Tampere, 33270, Finland</p>
        <p>General: support@kidssizefinder.com<br />Privacy: privacy@kidssizefinder.com</p>
      </main>

      <footer className="doc-footer" data-testid="terms-footer">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:support@kidssizefinder.com">Support</a>
        </div>
        <p className="footer-copy">© 2026 Outgrow Solutions Oy. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsPage;
